<script setup lang="ts">
import type { Configurator } from '~/models/configurator/configurator.model'
import ConfiguratorContainer from '~/components/configurator/ConfiguratorContainer.vue'
import { configuratorDtoSchema, transformConfiguratorDtoToConfigurator } from '~/models/configurator/configuratorDto.model'

const { $directus, $readSingleton } = useNuxtApp()
const { t } = useI18n()

const { data } = await useAsyncData('configurator', async () => {
  return $directus.request($readSingleton('configurator', {
    deep: {
      pools: {
        _limit: -1,
      },
    },
    limit: -1,
    fields: [
      'id',
      'form',
      {
        translations: ['*'],
        background_image_day: [
          { '*': ['*'] },
        ],
        background_image_night: [
          { '*': ['*'] },
        ],
        pools: [
          'id',
          {
            pool_line: [
              { '*': ['*'] },
            ],
            color: [
              { '*': ['*'] },
            ],
            size: [
              { '*': ['*'] },
            ],
            stair: [
              { '*': ['*'] },
            ],
            pool_image: [
              { '*': ['*'] },
            ],
            pool_image_deck: [
              { '*': ['*'] },
            ],
            pool_image_night: [
              { '*': ['*'] },
            ],
            pool_image_empty: [
              { '*': ['*'] },
            ],
          },
        ],
      },
    ],
  }))
})

const configuratorData = computed<Configurator | null>(() => {
  if (!data.value)
    return null
  const parsedResponse = configuratorDtoSchema.parse(data.value)
  const transformedConfigurator = transformConfiguratorDtoToConfigurator(parsedResponse)
  return transformedConfigurator
})

const route = useRoute()

const isFullyFilledIn = !!route.query.poolLine && !!route.query.stair && !!route.query.color && !!route.query.size
</script>

<template>
  <div class="flex flex-col pb-20 pt-32 text-neutral-white lg:h-screen 2xl:pt-60 lg:pt-48">
    <h1 class="sr-only">
      {{ t('configurator.title') }}
    </h1>
    <ConfiguratorContainer
      v-if="configuratorData !== null"
      :configurator="configuratorData"
      :is-fully-filled-in="isFullyFilledIn"
    />
    <!-- <pre>{{ data }}</pre> -->
  </div>
</template>
